import { Environment } from './environment';
import {
  LOCAL_HOSTNAMES,
  PRODUCTION_HOSTNAMES,
  STAGING_HOSTNAMES,
  TESTING_HOSTNAMES,
} from './hostnames';

export function isEnvironmentLocal(): boolean {
  return LOCAL_HOSTNAMES.includes(window.location.hostname);
}

export function isEnvironmentStaging(): boolean {
  return STAGING_HOSTNAMES.includes(window.location.hostname);
}

export function isEnvironmentTesting(): boolean {
  return TESTING_HOSTNAMES.includes(window.location.hostname);
}

export function isEnvironmentProduction(): boolean {
  return PRODUCTION_HOSTNAMES.includes(window.location.hostname);
}

export function isEnvironmentEphemeral(): boolean {
  return (
    window.location.hostname.startsWith('ephemeral-') &&
    window.location.hostname.endsWith('.use1-a.eks.color.dev')
  );
}

export function isEnvironmentLocalAndDevelopment(): boolean {
  // eslint-disable-next-line no-underscore-dangle
  return isEnvironmentLocal() && window.__ENV__ === 'development';
}

export function isEnvironmentCypressTest(): boolean {
  return isEnvironmentLocal() && window.Cypress !== undefined;
}

/**
 * Returns the environment based on the hostname. Useful for enabling functionality (i.e. different log levels, tooling, etc),
 * targeting different API hosts, and initializing 3rd party libraries based on the environment. If hostname is unknown, will
 * return Environment.UNKNOWN.
 *
 * @returns {Environment} The current environment
 */
export function getEnvironment(): Environment {
  if (isEnvironmentCypressTest()) {
    return Environment.CYPRESS_TEST;
  }
  if (isEnvironmentLocal()) {
    return Environment.LOCAL;
  }
  if (isEnvironmentStaging()) {
    return Environment.STAGING;
  }
  if (isEnvironmentTesting()) {
    return Environment.TESTING;
  }
  if (isEnvironmentProduction()) {
    return Environment.PRODUCTION;
  }
  if (isEnvironmentEphemeral()) {
    return Environment.EPHEMERAL;
  }
  return Environment.UNKNOWN;
}

/**
 * Returns the environment based on the hostname. Useful for enabling functionality (i.e. different log levels, tooling, etc),
 * targeting different API hosts, and initializing 3rd party libraries based on the environment. If hostname is unknown, will
 * return `defaultEnv`.
 *
 * @returns {Environment} The current environment
 */
export function getEnvironmentOrDefault(defaultEnv: Environment): Environment {
  if (isEnvironmentLocal()) {
    return Environment.LOCAL;
  }
  if (isEnvironmentStaging()) {
    return Environment.STAGING;
  }
  if (isEnvironmentTesting()) {
    return Environment.TESTING;
  }
  if (isEnvironmentProduction()) {
    return Environment.PRODUCTION;
  }
  return defaultEnv;
}
